<template>
  <div class="contact__map locator__map">
    <GmapMap :center="center" :zoom="12" style="width: 100%; height: 100%" @click="fetchContacts">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                        @closeclick="infoWinOpen=false">
        <div v-html="infoContent"/>
      </gmap-info-window>
    </GmapMap>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import map from 'lodash/map';
  import {fetchContacts} from './api';
  import {NAMESPACE} from './store';
  import {SECTION_TYPE} from './getter';
  import {TAB_NEAREST} from './constants';

  export default {
    name: 'ContactMap',
    data: () => {
      return {
        center: {
          lat: 50.080388,
          lng: 14.410427
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
      }
    },
    computed: {
      ...mapGetters(NAMESPACE, [SECTION_TYPE]),
    },
    methods: {
      fetchContacts(event) {
        this.infoWindowPos = event.latLng;
        this.infoContent = null;
        this.infoWinOpen = false;
        fetchContacts({lat: event.latLng.lat(), lng: event.latLng.lng()}, this[SECTION_TYPE], TAB_NEAREST)
        .then((data) => {
          this.infoContent = this.prepareContacts(data);
          this.infoWinOpen = true;
        })
        .catch(() => this.infoContent = 'Nenašli jsme žádné dostupné kontakty.');

      },
      prepareContacts(contacts) {
        return map(contacts, (contact) => this.prepareContentWindow(contact)).join('<hr/>');
      },
      prepareContentWindow(contact) {
        return `
                    <strong>${contact.name} ${contact.surname}</strong><br/>
                    ${contact.email}<br/>
                    ${contact.phone}<br/>
                `;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/Map.vue